export const getKeyCommand = (
  osx: boolean,
  func: (keys: { ctrl: string; alt: string; shift: string }) => string
): string => {
  let ctrl = 'Ctrl + ';
  let alt = 'Alt + ';
  let shift = 'Shift + ';
  if (osx) {
    ctrl = '⌘';
    alt = '⌥';
    shift = '⇧';
  }
  return func({ ctrl, alt, shift });
};

export default getKeyCommand;
